import '@main';

// animation box
const animationBox = document.querySelector<HTMLElement>('.j-animation-box');
const animationDiv = document.querySelector<HTMLDivElement>('#animationDiv');
const animationTypingBoxes = document.querySelectorAll<HTMLDivElement>('.j-animation-box-inner');

const observer = new IntersectionObserver(([entry], observer) => {
    if (entry.isIntersecting) {

      animationBox?.classList.add('active');

      animationTypingBoxes.forEach((animationTypingbox) => {
        animationTypingbox?.classList.add('active');
      });
    }
  },
  {
    root: null,
    rootMargin: '300px 0px -300px 0px',
    threshold: 0
  }
);

if (animationDiv) {
  observer.observe(animationDiv);
}
